import * as React from "react";
import messages from "@/messages";
import contract, { Feature } from "@/utils/contract";
import ContractContext, { initContractStore } from "@/contexts/Contract";

type IPrivacyPolicyLabelText = {
  PRIVACY_POLICY_LABEL_TEXT: string | undefined;
};

export const usePrivacyPolicyLabelText = (): IPrivacyPolicyLabelText => {
  const {
    state: { featuresObj },
  } = React.useContext(ContractContext) || initContractStore(contract);

  const PRIVACY_POLICY_LABEL_TEXT =
    featuresObj[Feature.NEW_DM_WEB_DESIGN] &&
    featuresObj[Feature.PRIVACY_POLICY_LABEL_TEXT] &&
    featuresObj[Feature.NEW_DM_WEB_DESIGN]?.enabled &&
    featuresObj[Feature.PRIVACY_POLICY_LABEL_TEXT]?.text
      ? featuresObj[Feature.PRIVACY_POLICY_LABEL_TEXT]?.text
      : messages.privacyPolicy;
  return {
    PRIVACY_POLICY_LABEL_TEXT,
  };
};
